import React, { useState } from "react";
import "../About.css";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { Modal, Button, Form } from "react-bootstrap";

function AboutUs() {
  const currentYear = new Date().getFullYear();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [message, setMessage] = useState("");
  const [showEmailModal, setShowEmailModal] = useState(false);

  const back = () => {
    navigate("/");
  };
  const openWinnerModal = async () => {
    setShowEmailModal(true);
  };

  const checkWinner = async () => {
    try {
      const response = await axios.get(
        `https://sheets.googleapis.com/v4/spreadsheets/1a6ziPtgBl1kxIEuScobNPbXhz_AKYhF6BAHVsCEALYQ/values/Sheet1!A:A?key=AIzaSyBQ0JAefzOmLNKKHTbJZaj8ZOILA82_L3A`
      );
      const emails = response.data.values.flat();
      return emails.includes(email);
    } catch (error) {
      console.error("Error fetching data from Google Sheets:", error);
      return false;
    }
  };

  const handleEmailCheck = async (e) => {
    e.preventDefault();
    const isWinner = await checkWinner();
    if (isWinner) {
      setMessage(
        "Congratulations! You are a winner. Check your email for instructions."
      );
    } else {
      setMessage(
        "Sorry, you are not a winner yet. You are still enrolled in today’s raffle."
      );
    }
  };

  return (
    <div className="about-container">
      <h1>About Vocaps</h1>
      {/* <div className="flex items-center justify-center h-screen">
      <form onSubmit={handleEmailCheck} className="w-full max-w-sm">
        <input
          type="email"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          placeholder="Enter your email"
          required
          className="border p-2 mb-4 w-full"
        />
        <button
          type="submit"
          className="bg-blue-500 text-white p-2 w-full"
        >
          Check Winner
        </button>
      </form>
      {message && <p>{message}</p>}
      </div> */}
      <section className="purpose-section">
        <h2>Purpose</h2>
        <p>
          An interactive language learning game to help improve your working
          vocabulary.
        </p>
      </section>

      <section className="how-to-play-section">
        <h2>How to Play</h2>
        <p>
          Select a language and game mode to begin play. The two game modes are
          "Free Style" and "Timed Game". Insert the correct letter to complete
          each word puzzle.
        </p>
        <p>
          Free Style is intended for passive learning. Each puzzle will resolve
          itself through an elimination process. Timed Game will test your
          knowledge as you race against a countdown timer.
        </p>
        <h2>General Inquiries</h2>
        <p>
          Contact our support team via email at support@vocaps.com to report any
          issues with a word puzzle or general gameplay. Please attach a
          screenshot to the email to help expedite inquiries.
        </p>
        {/* <p>Use "Hint" as needed.</p>
        <p>You may skip to the next word puzzle by "Show Answer" Button.</p>
        <p>
          Each game will start with 500 coins. Earn coins by completing the
          puzzles correctly. Earn your entry ticket into GP Daily raffle by
          accruing 2500 coins. */}
        {/* Create an account on{" "}
          <a
            href="https://www.goodppls.com"
            target="_blank"
            rel="noopener noreferrer"
          >
            www.goodppls.com
          </a>{" "}
          to redeem prizes. */}
        {/* </p> */}
      </section>

      {/* <section className="prize-structure-section">
        <h2>Prize Structure</h2>
        <ul>
          <li style={{ width: "50%" }}>
            2,500 Coins, Free entry ticket into GP Daily raffle®
          </li>
          <li
            style={{ width: "50%", cursor: "pointer" }}
            onClick={openWinnerModal}
          >
            Claim Raffle
          </li>
          <li style={{ width: "50%" }}>1,000 Coins: 10% off discount code</li>
          <li style={{ width: "50%" }}>3,000 Coins: 30% off discount code</li>
          <li style={{ width: "50%" }}>10,000 Coins: 50% off discount code</li>
          <li style={{ width: "50%" }}>50,000 Coins: 90% off discount code</li>
        </ul>
      </section> */}
      <div class="make-center">
        <button class="back-btn" onClick={back}>
          Go back
        </button>
      </div>
      <Modal show={showEmailModal} onHide={() => setShowEmailModal(false)}>
        <Modal.Header closeButton>
          <Modal.Title>Check Raffle Selection</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form onSubmit={handleEmailCheck}>
            <Form.Group controlId="formEmail">
              <Form.Label>Email address</Form.Label>
              <Form.Control
                type="email"
                placeholder="Type email address here to be entered into our raffle"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                required
              />
            </Form.Group>
            <Button variant="primary" type="submit" className="btn btn2 mb-4">
              Check
            </Button>
            {message && <p>{message}</p>}
          </Form>
        </Modal.Body>
      </Modal>
      <footer>
        <p>Vocaps ©{currentYear}.</p>
      </footer>
    </div>
  );
}

export default AboutUs;
